export const emailElementType = {
  //SINGLEPARTS
 /*  SMALL_HEADER_IMAGE: "TOP_HEADER_IMAGE", */
  LARGE_HEADER_IMAGE: "LARGE_HEADER_IMAGE",
  SPACE: "SPACE",
  BUTTON: "BUTTON",
  TEXT: "TEXT",

  //MULTIPARTS
  HEADLINE_TEXT_LIST_BUTTON: "HEADLINE_TEXT_LIST_BUTTON",
  BACKDROPIMAGE_ELEVATED_TEXT: "BACKDROPIMAGE_ELEVATED_TEXT",
  TWO_COL_IMAGE_TEXT: "TWO_COL_IMAGE_TEXT",
  THREE_COL_IMAGE_TEXT: "THREE_COL_IMAGE_TEXT",
  LEFT_THUMBNAIL_IMAGE_HEADLINE_TEXT_BUTTON: "LEFT_THUMBNAIL_IMAGE_HEADLINE_TEXT_BUTTON",
  RIGHT_THUMBNAIL_IMAGE_HEADLINE_TEXT_BUTTON: "RIGHT_THUMBNAIL_IMAGE_HEADLINE_TEXT_BUTTON",
  FOOTER: "FOOTER",
  FULL_BLEED_SECTION: "FULL_BLEED_SECTION",
  CALENDAR_INVITATION: "CALENDAR_INVITATION",
  SIMPLE: "SIMPLE",
  MULTI: "MULTI",
};
export const emailElementFamilyTypes = {
  text: "text",
  button: "button",
};
